import swal from 'sweetalert';

export default (function (ctx, inject) {
    inject('swal', swal);
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/sweetalert.js
// module id = ./src/plugins/sweetalert.js
// module chunks = 34